import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { BatchStatusBadge } from "@/components/StatusBadge";
import { Truck } from "lucide-react";

export default function AdminOutboundBatches() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/outbound-batches")
      .then(r => setRows(r.data))
      .catch(e => toast.error(formatApiError(e)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-batches-page" className="space-y-5">
      <div>
        <div className="text-xs font-mono-tech uppercase tracking-[0.2em] text-cyan-400 mb-1">/ Warehouse</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Outbound Batches</h1>
        <p className="text-slate-600 dark:text-slate-400 mt-1 text-sm">Read-only view of all warehouse outbound batches.</p>
      </div>
      {loading ? (
        <div className="py-14 text-center text-slate-500">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="border border-dashed border-slate-200 dark:border-slate-800 rounded-lg py-14 text-center bg-slate-100/30 dark:bg-slate-900/30 text-slate-500">
          <Truck className="w-10 h-10 text-slate-700 mx-auto mb-3" /> No batches yet.
        </div>
      ) : (
        <div className="border border-slate-200 dark:border-slate-800 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-100/60 dark:bg-slate-900/60 text-[11px] font-mono-tech uppercase tracking-wider text-slate-500">
              <tr>
                <th className="text-left px-4 py-3">Batch</th>
                <th className="text-left px-4 py-3">Warehouse</th>
                <th className="text-left px-4 py-3">Destination</th>
                <th className="text-left px-4 py-3">Pkgs</th>
                <th className="text-left px-4 py-3">Status</th>
                <th className="text-left px-4 py-3">Created</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
              {rows.map(b => (
                <tr key={b.id} data-testid={`admin-batch-${b.batch_code}`} className="hover:bg-slate-100/40 hover:dark:bg-slate-900/40">
                  <td className="px-4 py-3">
                    <div className="font-mono-tech text-xs text-cyan-300">{b.batch_code}</div>
                    <div className="text-slate-900 dark:text-white">{b.batch_name}</div>
                  </td>
                  <td className="px-4 py-3 text-slate-700 dark:text-slate-300">{b.warehouse_name}</td>
                  <td className="px-4 py-3 text-slate-700 dark:text-slate-300">{b.destination_area || "—"}</td>
                  <td className="px-4 py-3 text-slate-700 dark:text-slate-300">{b.total_packages || 0}</td>
                  <td className="px-4 py-3"><BatchStatusBadge status={b.status} /></td>
                  <td className="px-4 py-3 text-xs text-slate-600 dark:text-slate-400">{new Date(b.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
